import React from "react";
import { useNavigate } from "react-router-dom";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useConfiguration } from "../../api/configurations/use-configuration";
import { KimcheeStandingPose } from "../../images/KimcheeStandingPose";
import { AI_ROUTES } from "../../routes/routes";
import { TestPilotButton } from "../Buttons/TestPilotButton";

export const ScreenshotRecommendationsPanel = () => {
  const navigate = useNavigate();

  const hasAccess = useConfiguration<boolean>("enable_ai")?.value;

  if (!hasAccess) {
    return null;
  }

  return (
    <IgPaper
      sx={{ padding: "15px 30px 15px 30px", backgroundColor: "#F7E9DC" }}
    >
      <Grid
        container
        columnSpacing={2}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid
          container
          item
          alignItems={"center"}
          columnSpacing={2}
          xs={10}
          flexWrap={"nowrap"}
        >
          <Grid item>
            <KimcheeStandingPose
              sx={{
                width: "100px",
                height: "100px",
                marginTop: "p-2x",
                marginBottom: "-5px",
              }}
            />
          </Grid>
          <Grid item>
            <Grid item>
              <IgTypography sx={{ fontWeight: 600, fontSize: "18px" }}>
                Not sure what to test next?{" "}
              </IgTypography>
              <IgTypography>
                We've got you covered! Abie, our friendly AI pupstronaut, can
                help brainstorm with you.
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={2} justifyContent={"end"}>
          <TestPilotButton
            onClick={() => navigate(AI_ROUTES.ScreenshotRecommendations)}
            dark={true}
          />
        </Grid>
      </Grid>
    </IgPaper>
  );
};
